import { EventName } from '@lit/react';
import { BlocksInlineNotification } from 'blocks-nextjs/blocks-web-components/components/inline-notification/inline-notification';
import { BlocksCancelEvent, BlocksCloseEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatInlineNotification = createComponent({
  react: React,
  tagName: 'cat-inline-notification',
  elementClass: BlocksInlineNotification,
  events: {
    onBlInlineNotificationClose: 'bl-inline-notification-close' as EventName<BlocksCloseEvent>,
    onBlInlineNotificationCancel: 'bl-inline-notification-cancel' as EventName<BlocksCancelEvent>,
    onBlInlineNotificationOpen: 'bl-inline-notification-open' as EventName<BlocksCancelEvent>
  }
});
